
export default {
    props: ['value', 'label', 'name' , 'required', 'disabled', 'placeholder', 'password', 'error', 'help'],
    data() {
        return {
            isFocused: false,
        };
    },
}
